import React from 'react'
import styled from 'styled-components'
import Header from './Header'
import LoadInView from './LoadInView'
import Footer from './Footer'

const NotFound = () => {
    return (
        <>
            <Header />
            <LoadInView>
                <Container>
                    <ContentWrapper>
                        <div className='title'>404 NotFound</div>
                        <div className='desc'>click <a href="/">here</a> to return</div>
                    </ContentWrapper>
                </Container>
            </LoadInView>
            <Footer />
        </>
    )
}

export default NotFound

const Container = styled.div`
    max-width: 450px;
    height: 400px;
    margin: 0 auto;
    // border: 1px solid #aaa;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
`

const ContentWrapper = styled.div`
    // text-align: center;
    .title{
        font-size: 60px;
        font-weight: 700;
    }

    .desc {
        font-size: 18px;
    }
`